import { ContentLink } from "@components/cms/link/ContentLink";
import { RichText } from "@components/cms/rich-text-renderer/RichText";
import type { CardGenericModel } from "@lib/contentful/mappers/modules/cardGeneric/types";
import { Button } from "@ecco/ui/button";
import { Box } from "@ecco/ui/box";
import { Card } from "@ecco/ui/card";
import { ECCOIcon } from "@ecco/ui/ecco-icon";
import type { FC } from "react";

export const CardGeneric: FC<CardGenericModel> = ({
    text,
    icon,
    linkButton,
    mergeWithPrevious,
    showPrintPDFLabel,
    printPDFLabel,
}) => (
    <Card mergeWithPreviousCard={mergeWithPrevious} sx={{ "@media print": { display: "none" } }}>
        {icon && <ECCOIcon name={icon} size="xl" />}
        <Box
            sx={{
                "& p": {
                    color: "black",
                    ...(showPrintPDFLabel && { mb: 0 }),
                },
                "& p:empty::before": {
                    content: "'\\A'",
                    whiteSpace: "pre",
                },
                span: {
                    display: "block",
                    fontWeight: "semibold",
                    color: "black",
                    mb: showPrintPDFLabel ? 0 : 2,
                },
            }}
            fontWeight="semibold"
        >
            <RichText data={text} />
        </Box>
        {linkButton && (
            <Button
                rightIcon={<ECCOIcon name="arrow-right" />}
                as={ContentLink}
                link={linkButton}
                variant="outline"
                w="full"
                h="full"
                textDecoration="none"
                sx={{
                    // The link renders as a button, so drop Link's own underline and color.
                    "& span, & span:hover": {
                        textDecoration: "none",
                        color: "black",
                    },
                    "&:hover": {
                        textDecoration: "none",
                    },
                }}
            >
                <span>{linkButton.label}</span>
            </Button>
        )}
        {showPrintPDFLabel && printPDFLabel && (
            <Button
                variant="standard"
                w="fit-content"
                h="fit-content"
                onClick={() => window.print()}
                textDecoration="none"
                sx={{
                    "&:hover": {
                        textDecoration: "none",
                    },
                }}
            >
                <span>{printPDFLabel}</span>
            </Button>
        )}
    </Card>
);
